import React from "react";
import { Tooltip } from "antd";
import { TA, IN, TEST_AGENCY, INACTIVE_AGENCY } from "../utils/Constants";

const AgencyBadge = ({ showTest, showInactive }) => {
   
  return (
    <span>
      {showTest && (
        <Tooltip title={<span>{TEST_AGENCY}</span>}>
          <span className="text-red margin-left-5">
            ({TA})
          </span>
        </Tooltip>
      )}

      {showInactive && (
        <Tooltip title={<span>{INACTIVE_AGENCY}</span>}>
          <span className="text-red margin-left-5">
            ({IN})
          </span>
        </Tooltip>
      )}
    </span>
  );
};

export default AgencyBadge;



// WEBPACK FOOTER //
// ./src/Custom-Tooltip/AgencyBadge.js